module.exports = __webpack_public_path__ + "img/allow-up-white.3a48389c.svg";